import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function DatenschutzPage() {
  return <div className="min-h-screen bg-white" data-id="element-1075">
      <Header data-id="element-1076" />
      <main className="w-full pt-32" data-id="element-1077">
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1078">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1079">
            Datenschutzerklärung
          </h1>
          <section className="mb-12" data-id="element-1080">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1081">
              1. Verantwortliche im Sinne der Datenschutz-Grundverordnung
              (DSGVO)
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1082">
              <p className="font-medium" data-id="element-1083">Dr. Angelika Sturny</p>
              <p data-id="element-1084">Praxis für Beratung und Psychotherapie</p>
              <p data-id="element-1085">Feinerweg 18</p>
              <p data-id="element-1086">85540 Haar (b. München)</p>
              <p data-id="element-1087">
                E-Mail:{' '}
                <a href="mailto:praxis@angelikasturny.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1088">
                  praxis@angelikasturny.com
                </a>
              </p>
              <p data-id="element-1089">Telefon: +49 151 22 89 34 02</p>
              <p className="font-medium mt-6" data-id="element-1090">Eva Sophie Schifferer</p>
              <p data-id="element-1091">Praxis für Psychotherapie und Coaching</p>
              <p data-id="element-1092">Günthersburgallee 82</p>
              <p data-id="element-1093">60389 Frankfurt am Main</p>
              <p data-id="element-1094">
                E-Mail:{' '}
                <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1095">
                  praxis@evaschifferer.com
                </a>
              </p>
              <p data-id="element-1096">Telefon: +49 171 80 80 455</p>
              <p className="mt-6" data-id="element-1097">
                Beide Verantwortlichen betreiben diese Website{' '}
                <strong data-id="element-1098">
                  gemeinsam unter der Domain{' '}
                  <a href="https://beratung-psychotherapie.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1099">
                    beratung-psychotherapie.com
                  </a>
                </strong>
                , handeln jedoch <strong data-id="element-1100">jeweils eigenständig</strong> im Rahmen
                ihrer eigenen Praxistätigkeit.
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1101" />
          <section className="mb-12" data-id="element-1102">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1103">
              2. Allgemeines zur Datenverarbeitung
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1104">
              <p data-id="element-1105">Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst.</p>
              <p data-id="element-1106">
                Personenbezogene Daten werden auf dieser Website nur im
                erforderlichen Umfang verarbeitet.
              </p>
              <p data-id="element-1107">
                Die Verarbeitung erfolgt stets im Einklang mit der
                Datenschutz-Grundverordnung (DSGVO) sowie den landesspezifischen
                Datenschutzbestimmungen.
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1108" />
          <section className="mb-12" data-id="element-1109">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1110">
              3. Erhebung und Speicherung personenbezogener Daten sowie Art und
              Zweck ihrer Verwendung
            </h2>
            <div className="mb-8" data-id="element-1111">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1112">
                a) Beim Besuch der Website
              </h3>
              <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1113">
                <p data-id="element-1114">
                  Beim Aufrufen unserer Website werden durch den auf Ihrem
                  Endgerät zum Einsatz kommenden Browser automatisch
                  Informationen an den Server unserer Website gesendet.
                </p>
                <p data-id="element-1115">
                  Diese Informationen werden temporär in sogenannten{' '}
                  <strong data-id="element-1116">Server-Logfiles</strong> gespeichert. Erfasst werden
                  können u. a.:
                </p>
                <ul className="list-disc pl-5 space-y-1" data-id="element-1117">
                  <li data-id="element-1118">IP-Adresse des anfragenden Rechners</li>
                  <li data-id="element-1119">Datum und Uhrzeit des Zugriffs</li>
                  <li data-id="element-1120">Name und URL der abgerufenen Datei</li>
                  <li data-id="element-1121">
                    Website, von der aus der Zugriff erfolgt (Referrer-URL)
                  </li>
                  <li data-id="element-1122">
                    verwendeter Browser und ggf. Betriebssystem Ihres Rechners
                  </li>
                </ul>
                <p data-id="element-1123">
                  Die genannten Daten werden durch den Hoster (checkdomain.de)
                  zu folgenden Zwecken verarbeitet:
                </p>
                <ul className="list-disc pl-5 space-y-1" data-id="element-1124">
                  <li data-id="element-1125">
                    Gewährleistung eines reibungslosen Verbindungsaufbaus der
                    Website
                  </li>
                  <li data-id="element-1126">Gewährleistung einer komfortablen Nutzung der Website</li>
                  <li data-id="element-1127">Auswertung der Systemsicherheit und -stabilität</li>
                  <li data-id="element-1128">administrative Zwecke</li>
                </ul>
                <p data-id="element-1129">
                  <strong data-id="element-1130">Rechtsgrundlage:</strong> Art. 6 Abs. 1 f DSGVO
                  (berechtigtes Interesse)
                </p>
                <p data-id="element-1131">
                  Die erhobenen Daten werden <strong data-id="element-1132">nicht</strong> zu
                  Marketingzwecken verwendet und{' '}
                  <strong data-id="element-1133">nach spätestens 7 Tagen gelöscht</strong>.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-1134">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1135">
                b) Kontaktaufnahme per E-Mail
              </h3>
              <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1136">
                <p data-id="element-1137">
                  Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben
                  (Name, E-Mail-Adresse, Inhalt der Nachricht) ausschließlich
                  zur Bearbeitung Ihres Anliegens verarbeitet.
                </p>
                <p data-id="element-1138">Eine Weitergabe an Dritte findet nicht statt.</p>
                <p data-id="element-1139">
                  <strong data-id="element-1140">Rechtsgrundlage:</strong> Art. 6 Abs. 1 b DSGVO
                  (Vertragserfüllung bzw. vorvertragliche Maßnahmen)
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-1141">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1142">
                c) Terminbuchung über Zeeg.me
              </h3>
              <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1143">
                <p data-id="element-1144">
                  Für die Terminvereinbarung nutzen wir den Dienst Zeeg.me
                  (Betreiber: Zeeg GmbH, Pariser Straße 3, 10719 Berlin,
                  Deutschland).
                </p>
                <p data-id="element-1145">
                  Wenn Sie über einen Zeeg-Link einen Termin buchen, werden die
                  von Ihnen angegebenen Daten (z. B. Name, E-Mail-Adresse, ggf.
                  Telefonnummer und Terminwunsch) an Zeeg übertragen. Diese
                  Daten werden ausschließlich zum Zweck der Terminplanung und
                  -koordination verarbeitet.
                </p>
                <p data-id="element-1146">
                  Zeeg verarbeitet personenbezogene Daten gemäß den Vorgaben der
                  DSGVO und speichert diese auf Servern innerhalb der
                  Europäischen Union. Ein Auftragsverarbeitungsvertrag (AVV)
                  gemäß Art. 28 DSGVO wurde mit Zeeg geschlossen.
                </p>
                <p data-id="element-1147">
                  Weitere Informationen zum Datenschutz bei Zeeg finden Sie
                  unter:{' '}
                  <a href="https://zeeg.me/privacy" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1148">
                    https://zeeg.me/privacy
                  </a>
                </p>
                <p data-id="element-1149">
                  <strong data-id="element-1150">Rechtsgrundlage:</strong> Art. 6 Abs. 1 b DSGVO (zur
                  Durchführung vorvertraglicher Maßnahmen)
                </p>
              </div>
            </div>
            <div data-id="element-1151">
              <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-1152">
                d) Webanalyse mit Matomo (ohne Cookies)
              </h3>
              <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1153">
                <p data-id="element-1154">
                  Diese Website nutzt den datenschutzfreundlichen Analysedienst{' '}
                  <strong data-id="element-1155">Matomo</strong>, der ohne Cookies arbeitet und lokal
                  auf dem Server gehostet wird.
                </p>
                <p data-id="element-1156">Dabei werden keine personenbezogenen Profile erstellt.</p>
                <p data-id="element-1157">
                  Die IP-Adresse wird vor der Speicherung anonymisiert (Kürzung
                  der letzten beiden Oktette).
                </p>
                <p data-id="element-1158">
                  Eine Identifizierung einzelner Besucher ist dadurch nicht
                  möglich.
                </p>
                <p data-id="element-1159">
                  Wir verwenden Matomo, um das Nutzerverhalten anonymisiert
                  auszuwerten und unsere Website technisch zu optimieren.
                </p>
                <p data-id="element-1160">
                  Die Daten werden{' '}
                  <strong data-id="element-1161">nicht an Dritte weitergegeben</strong> oder mit
                  anderen Quellen zusammengeführt.
                </p>
                <p data-id="element-1162">
                  <strong data-id="element-1163">Rechtsgrundlage:</strong> Art. 6 Abs. 1 f DSGVO
                  (berechtigtes Interesse an der Analyse zur Verbesserung der
                  Website)
                </p>
              </div>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1164" />
          <section className="mb-12" data-id="element-1165">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1166">
              4. Weitergabe von Daten
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1167">
              <p data-id="element-1168">
                Eine Übermittlung Ihrer persönlichen Daten an Dritte findet
                grundsätzlich nicht statt, es sei denn:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-1169">
                <li data-id="element-1170">
                  Sie haben ausdrücklich eingewilligt (Art. 6 Abs. 1 a DSGVO)
                </li>
                <li data-id="element-1171">
                  die Verarbeitung ist zur Vertragserfüllung erforderlich (Art.
                  6 Abs. 1 b DSGVO)
                </li>
                <li data-id="element-1172">
                  eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 c DSGVO)
                </li>
              </ul>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1173" />
          <section className="mb-12" data-id="element-1174">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1175">
              5. Ihre Rechte als betroffene Person
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1176">
              <p data-id="element-1177">Sie haben folgende Rechte:</p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-1178">
                <li data-id="element-1179">
                  <strong data-id="element-1180">Auskunft</strong> über Ihre gespeicherten
                  personenbezogenen Daten (Art. 15 DSGVO)
                </li>
                <li data-id="element-1181">
                  <strong data-id="element-1182">Berichtigung</strong> unrichtiger Daten (Art. 16
                  DSGVO)
                </li>
                <li data-id="element-1183">
                  <strong data-id="element-1184">Löschung</strong> Ihrer Daten („Recht auf
                  Vergessenwerden", Art. 17 DSGVO)
                </li>
                <li data-id="element-1185">
                  <strong data-id="element-1186">Einschränkung der Verarbeitung</strong> (Art. 18
                  DSGVO)
                </li>
                <li data-id="element-1187">
                  <strong data-id="element-1188">Datenübertragbarkeit</strong> (Art. 20 DSGVO)
                </li>
                <li data-id="element-1189">
                  <strong data-id="element-1190">Widerspruch</strong> gegen die Verarbeitung (Art. 21
                  DSGVO)
                </li>
                <li data-id="element-1191">
                  <strong data-id="element-1192">Beschwerderecht</strong> bei einer Aufsichtsbehörde
                  (Art. 77 DSGVO)
                </li>
              </ul>
              <p className="mt-6" data-id="element-1193">Zuständige Datenschutzaufsichtsbehörden:</p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-1194">
                <li data-id="element-1195">
                  Für Dr. Angelika Sturny: Bayerisches Landesamt für
                  Datenschutzaufsicht (BayLDA),{' '}
                  <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1196">
                    www.lda.bayern.de
                  </a>
                </li>
                <li data-id="element-1197">
                  Für Eva Sophie Schifferer: Der Hessische Beauftragte für
                  Datenschutz und Informationsfreiheit,{' '}
                  <a href="https://www.datenschutz.hessen.de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1198">
                    www.datenschutz.hessen.de
                  </a>
                </li>
              </ul>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1199" />
          <section className="mb-12" data-id="element-1200">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1201">
              6. Datensicherheit
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1202">
              <p data-id="element-1203">
                Diese Website nutzt{' '}
                <strong data-id="element-1204">SSL- bzw. TLS-Verschlüsselung</strong> (HTTPS).
              </p>
              <p data-id="element-1205">
                Dadurch werden Daten, die Sie an uns übermitteln, vor unbefugtem
                Zugriff Dritter geschützt.
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1206" />
          <section data-id="element-1207">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1208">
              7. Aktualität und Änderung dieser Datenschutzerklärung
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1209">
              <p data-id="element-1210">
                Diese Datenschutzerklärung ist aktuell gültig (Stand: Oktober
                2025).
              </p>
              <p data-id="element-1211">
                Durch die Weiterentwicklung unserer Website oder geänderte
                gesetzliche Vorgaben kann eine Anpassung erforderlich werden.
              </p>
              <p data-id="element-1212">
                Die jeweils aktuelle Fassung finden Sie stets unter{' '}
                <a href="https://beratung-psychotherapie.com/datenschutz" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1213">
                  https://beratung-psychotherapie.com/datenschutz
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer data-id="element-1214" />
    </div>;
}